import { useDisclosure } from "@heroui/react";
import {
  ModalBuilder,
  ModalError,
  ModalField,
} from "@/app/components/modals/modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { loadHandbooks } from "@/utils/loadHandbooks";
import { useAppSelector } from "@/hooks/useAppSelector";

export function CreateCustomSystemModal({
  disclosure,
  type,
  fields,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  type: string;
  fields: ModalField[];
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErros] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();
  const businessProfileId = useAppSelector(
    (state) => state.businessProfile.businessProfile.id,
  );

  const onSubmit = (data: any) => {
    return new Promise<boolean>((resolve) => {
      api.lockSystems
        .create({
          display_name: data.displayName,
          business_profile_id: businessProfileId,
          type,
          credentials: data,
        })
        .then(() => {
          loadHandbooks({ handbooks: ["locks"] });
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          loadHandbooks({ handbooks: ["locks"] });
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Создание системы"
      fields={[
        {
          name: "displayName",
          type: "text",
          label: "Название",
          isRequired: true,
          placeholder: "Название системы",
        },
        ...fields,
      ]}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      modalErrors={modalErrors}
      onSubmit={onSubmit}
      isSensitiveData={true}
      submitButtonText="Сохранить"
      defaultValues={{
        displayName: "",
        ...fields.reduce((acc: Record<string, string>, field) => {
          acc[field.name] = "";
          return acc;
        }, {}),
      }}
    />
  );
}
